<template>
  <div
    class="w-full relative group"
    :class="{
      'h-64 overflow-hidden': !flat,
      'max-h-full': flat || edit,
      'bg-gray-300 animation-infinite animation-pulse animation-2s': !imageLoaded,
    }"
    v-in-viewport.once="setVisible"
  >
    <img
      class="w-full h-full object-cover"
      :class="{
        'cursor-pointer transform transition-transform duration-150 group-hover:scale-105': !flat,
        'opacity-0': !imageLoaded,
        'animation animation-once animation-1s animation-fade': imageLoaded,
      }"
      ref="image"
      @load="setLoaded"
      :src="localImage ? localImage.filepath : ''"
      :alt="localImage ? localImage.id : ''"
      @click="emitInput"
    />
    <div
      class="absolute top-0 right-0 p-2 text-white opacity-25 group-hover:opacity-100 transition-opacity duration-100 text-xl"
      v-if="edit"
    >
      <wd-button transparent @input="destroyImage">
        <span style="text-shadow: 2px 4px #333">
          <icon name="Trash" />
        </span>
      </wd-button>
    </div>
  </div>
</template>

<script>
import { Image } from "@/modules/images/viewmodels/Image";
import FormMixin from "@/mixins/FormMixin";

export default {
  name: "SingleImage",
  mixins: [FormMixin],
  data() {
    return {
      localImage: null,
      visible: false,
      imageLoaded: false
    };
  },
  props: {
    image: {
      type: Image,
    },
    imageId: {
      type: String,
    },
    flat: {
      default: false,
      type: Boolean,
    },
    edit: {
      default: false,
      type: Boolean,
    },
  },
  components: {},
  methods: {
    emitInput() {
      this.$emit("input");
    },
    async loadImage(ImageId){
      this.loading = true;
      this.imageLoaded = false;
      this.localImage = await this.$store.getters[
            "image/api"
        ].Custom.ShowObject(ImageId);
        this.loaded();
    },
    destroyImage() {
      let popupTitle = this.$t("images.image_was_deleted");
      this.$store.dispatch("dialog/add", {
        title: "Löschen bestätigen",
        text: `Bild wirklich löschen?`,
        submitFn: () => {
          this.submit({
            async: true,
            type: "image",
            call: "destroy",
            id: this.image.id,
            action: (response) => {
              this.popup({
                type: "success",
                title: popupTitle,
              });
            },
          });
        },
      });
    },
    async setVisible(){
      if (this.imageId && !this.imageLoaded){
        await this.loadImage(this.imageId);
      }
    },
    setLoaded(){
      this.imageLoaded = true;
    }
  },
  computed: {
  },
  async created() {
    if (this.image) {
      this.localImage = this.image;
    }
  },
  mounted() {},
  watch: {
    imageId: {
      immediate: true,
      async handler(val, oldVal) {
        if (val) {
          await this.loadImage(val);
        }
      },
    },
  },
};
</script>
